export const setLogin=(value)=>({type:'setLogin',value});
